module.exports = __webpack_public_path__ + "static/img/logo.736a1ed2.png";